import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import UploadFile from '@components/UploadFile'
import DeleteIcon from '@components/Icon/Delete'
import Tooltip from '@components/Tooltip/Tooltip'
import InfoIcon from '@components/Icon/Info'
import DownloadIcon from '@components/Icon/Download'
import { isCancellationError } from '@components/Dialog'
import { tokenStorage, formatDate } from '@atheneum/api/dist/lib'
import find from 'lodash/find'

class Attachment extends Component {
  static propTypes = {
    url: PropTypes.string,
    onOk: PropTypes.func,
    onDelete: PropTypes.func,
    readOnly: PropTypes.bool,
    attachments: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    label: PropTypes.string,
    labelButton: PropTypes.string,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    growlStore: PropTypes.object,
    employeeStore: PropTypes.object
  }

  downloadAttachment = (e, attachment) => {
    e.preventDefault()
    const iframe = document.querySelector('iframe#download-iframe')
    const formTemplate =
      '<form method="POST" action="/api/file/' +
      attachment.path +
      '"><input type="hidden" name="token" value="' +
      localStorage.getItem('ngStorage-accessToken') +
      '" /></form>'
    const tmp = document.createElement('div')
    tmp.innerHTML = formTemplate
    const form = tmp.firstChild
    tmp.innerHTML = ''
    iframe.appendChild(form)
    form.submit()
  }

  handleDelete = async attachmentId => {
    const { onDelete, growlStore } = this.props

    try {
      await onDelete(attachmentId)
    } catch (err) {
      if (isCancellationError(err)) return

      growlStore.showError(err)
    }
  }

  renderAttachments = () => {
    const { attachments } = this.props
    if (!attachments || attachments.length < 1) return <p>No attachments...</p>

    return attachments.map(attachment => {
      const openableTypes = [
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'application/pdf',
        'image/png',
        'text/plain'
      ]

      const employee = find(this.props.employeeStore.employees, { value: attachment.userId })

      if (openableTypes.includes(attachment.type)) {
        return this.renderFileOpenerLink({
          ...attachment,
          path: encodeURIComponent(attachment.path),
          employee: employee.label
        })
      }

      return this.renderDownloadLink({
        ...attachment,
        path: encodeURIComponent(attachment.path),
        employee: employee.label
      })
    })
  }

  renderDownloadLink = attachment => {
    return (
      <span key={attachment.id}>
        <a href="" onClick={e => this.downloadAttachment(e, attachment)}>
          {attachment.name}
        </a>
        <div
          className="delete-icon"
          onClick={() => this.handleDelete(attachment.id)}>
          {!this.props.readOnly && <DeleteIcon />}
        </div>
        <div className="uploaded-by">uploaded by {attachment.employee} on {formatDate(attachment.updated_at)}</div>
      </span>
    )
  }

  renderFileOpenerLink = attachment => {
    return (
      <span key={attachment.id}>
        <a
          target="_blank"
          href={
            '/api/file/' + attachment.path + '?token=' + tokenStorage.get()
          } rel="noreferrer">
          {attachment.name}
        </a>
        <a
          href=""
          className="delete-icon"
          onClick={e => this.downloadAttachment(e, attachment)}>
          <DownloadIcon />
        </a>
        <div
          className="delete-icon"
          onClick={() => this.handleDelete(attachment.id)}>
          {!this.props.readOnly && <DeleteIcon />}
        </div>
        <div className="uploaded-by">uploaded by {attachment.employee} on {formatDate(attachment.updated_at)}</div>
      </span>
    )
  }

  renderTooltip = () => {
    if (!this.props.tooltip) return null

    return (
      <Tooltip tooltip={this.props.tooltip} placement="top">
        <div className="iconWrapper">
          <InfoIcon />
        </div>
      </Tooltip>
    )
  }

  render () {
    return (
      <div className="story attachment-container">
        <span className="label">
          {this.props.label || 'Attachment'}
          {this.renderTooltip()}
        </span>
        <div className="attachment-wrapper">{this.renderAttachments()}</div>
        {!this.props.readOnly && (
          <UploadFile
            label={this.props.labelButton || 'Add attachment'}
            url={this.props.url}
            onOk={this.props.onOk}
            preUpload={this.props.preUpload}
          />
        )}
      </div>
    )
  }
}

export default inject('userStore', 'growlStore', 'employeeStore')(observer(Attachment))
